export const ISLOADING = "ISLOADING";
export const ISERROR = "ISERROR";
export const GETRECIPES = "GETRECIPES";
